import React from "react";
import { Link } from "react-router-dom";
import { Users, Home } from "lucide-react";
import Badge from "../../../components/Badge";
import OfflineItemBadge from "../../../components/OfflineItemBadge";
import { FAMILY_STATUSES } from "../../../lib/constants";
import { visitTone, visitLabel } from "../utils/visitStatus";

const STATUS_MAP = Object.fromEntries(FAMILY_STATUSES.map((s) => [s.value, s]));

export default function FamilyListCard({ family, animationIndex }) {
  const days   = family.days_since ?? family.last_visit_days;
  const status = STATUS_MAP[family.status];
  const count  = family.people_count;

  const animStyle = animationIndex != null
    ? { animation: "fadeUp 0.4s ease forwards", animationDelay: `${animationIndex * 40}ms`, opacity: 0 }
    : undefined;

  return (
    <Link
      to={`/families/${family.id}`}
      className="list-item-lazy block bg-white dark:bg-slate-800 p-4 rounded-[24px] border border-slate-200/50 dark:border-slate-700/50 shadow-card transition-all duration-300 ease-out hover:shadow-card-hover active:scale-[0.98] active:opacity-80"
      style={animStyle}
    >
      <div className="flex items-start gap-3">
        <Users size={18} className="text-emerald-600 dark:text-emerald-400 shrink-0 mt-0.5" />

        <div className="flex-1 min-w-0">
          {/* NAME + STATUS */}
          <div className="flex items-start justify-between gap-2">
            <p className="font-semibold text-[14px] text-slate-800 dark:text-slate-100 truncate leading-tight">
              {family.name}
            </p>
            <div className="flex items-center gap-1 shrink-0">
              <OfflineItemBadge item={family} />
              {status && <Badge tone={status.tone}>{status.label}</Badge>}
            </div>
          </div>

          {/* META ROW */}
          <div className="flex items-center gap-2 mt-1.5 flex-wrap">
            {family.is_pastoral_home && (
              <span className="inline-flex items-center gap-1 rounded-full bg-blue-50 dark:bg-blue-500/10 px-2 py-0.5 text-[10px] font-semibold text-[#1b4f9c] dark:text-blue-300">
                <Home size={11} />
                Familia pastoral
              </span>
            )}
            {count > 0 && (
              <span className="text-[11px] text-slate-500 dark:text-slate-400">
                {count} miembro{count !== 1 ? "s" : ""}
              </span>
            )}
            {days != null && (
              <>
                {count > 0 && <span className="text-[11px] text-slate-300 dark:text-slate-600">·</span>}
                <Badge tone={visitTone(days)}>{visitLabel(days)}</Badge>
              </>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}
